<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
  <path d="M12.6617 7.36692C13.1128 7.65932 13.1128 8.34068 12.6617 8.63308L6.10139 12.8853C5.62193 13.1961 5 12.8386 5 12.2522L5 3.74776C5 3.16138 5.62193 2.80389 6.10139 3.11467L12.6617 7.36692Z"/>
</svg>
